export const editorMoveObjectBackward = () => {
  const selection = window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  selection.sendBackwards();
  window.canvas.renderAll();
};
